// Dates as a person reads them. Each takes unix seconds.

const dayKey = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;

const time = (d) => d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

// "9 Nov"
export function shortDate(seconds) {
  return new Date(seconds * 1000).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

// "Thu 5 Nov"
export function dayAndDate(seconds) {
  return new Date(seconds * 1000).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
}

// "Today, 09:14", "Yesterday, 18:02" or "28 Oct, 11:30"
export function friendlyWhen(seconds) {
  const d = new Date(seconds * 1000);
  const now = new Date();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);

  if (dayKey(d) === dayKey(now)) return `Today, ${time(d)}`;
  if (dayKey(d) === dayKey(yesterday)) return `Yesterday, ${time(d)}`;
  return `${shortDate(seconds)}, ${time(d)}`;
}

// Whole days from now, at least 0.
export function daysFromNow(seconds) {
  return Math.max(0, Math.ceil((seconds * 1000 - Date.now()) / 86400000));
}
